import axios from 'axios';
import type { HistoryFindLogResponse, JsonObject } from '@/app-package';

export type FindLog = JsonObject<HistoryFindLogResponse>;

interface FindLogParams {
  type: 'Covid19Setting' | 'User' | 'Offer' | 'OfferSettings' | 'Transfer';
  id: string;
}

const findLog = async ({ type, id }: FindLogParams) => {
  const { data } = await axios.get<FindLog>(`/history/${type}/${id}`);
  return data;
};

export default findLog;
